import Select from "react-select";
// import { useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useState, useEffect, useMemo, useRef } from "react";
import { useAdditionalExperience } from "../../../context/AdditionalExperienceContext";
import { getAddExpInfo, calculateAddExpAmount, purchaseAddExp } from "../../../services/programService";
import GenericPaymentGateway from "../../payment/GenericPaymentGateway";
import { notification } from "antd";
import { getHtml } from "../../../helper";


const AdditionalExperienceModal = () => {
  const { isOpen, closeModal, bookingId, programId  } = useAdditionalExperience();
  const [step, setStep] = useState("experience"); // experience | payment
  const [paymentMethod, setPaymentMethod] = useState(0); // 1 = card, 4 = internet banking
  const [addExpData, setAddExpData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [campCode, setCampCode] = useState(null);
  const [activeExpId, setActiveExpId] = useState(null);
  const autoSelectedRef = useRef(false);
  // const [formError, setFormError] = useState("");




  const [booking, setBooking] = useState(null);
  const [program, setProgram] = useState(null);
  const [camper, setCamper] = useState(null);
  const [selectedExperiences, setSelectedExperiences] = useState([]);

  useEffect(() => {
    if (!isOpen) return;

    const fetchAddExp = async () => {
      setLoading(true);
      try {
        let query = "";

        if (bookingId) {
          query = `?bookingId=${bookingId}`;
        }
        const res = await getAddExpInfo(query);

        if (res?.data?.statusCode === 1) {
          const wrapper = res.data.responseData?.[0];

          setUserId(wrapper?.userId || null);
          setUserEmail(wrapper?.userEmail || null);
          let bookings = wrapper?.bookings || [];

          if (programId) {
            bookings = bookings.map(booking => ({
              ...booking,
              programs: booking.programs?.filter(
                p => p.programId === programId
              )
            })).filter(booking => booking.programs?.length > 0);
          }

          setAddExpData(bookings);

        }

      } catch (err) {
        console.error("Failed to fetch additional experience info", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAddExp();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      resetState();
    }
  }, [isOpen]);

  // useEffect(() => {
  //   if (!formError) return;

  //   const selected = selectedExperiences.filter(e => e.quantity > 0);

  //   const stillInvalid = selected.some(
  //     exp => exp.question && !isAnswerValid(exp.question)
  //   );

  //   if (!stillInvalid) {
  //     // setFormError("");
  //   }
  // }, [selectedExperiences, formError]);

  const resetState = () => {
    setStep("experience");
    setPaymentMethod(0);
    setPaymentInfo(null);

    setBooking(null);
    setProgram(null);
    setCamper(null);
    setSelectedExperiences([]);

    setUserId(null);
    setUserEmail(null);
    setCampCode(null);

    setAddExpData([]);
    // setFormError("");
  };

  const isAnswerValid = (question) => {
    if (!question || question.isRequred !== 1) return true;

    const answer = question.answer?.trim?.() ?? "";

    // TEXT
    if (question.questionType === 1) {
      return answer.length > 0;
    }

    // DROPDOWN
    if (question.questionType === 2) {
      return !!answer;
    }

    // CHECKBOX + OTHER
    if (question.questionType === 4) {
      // normal option selected
      if (!question.isOtherOptionSelected && answer.length > 0) {
        return true;
      }

      // other selected
      if (question.isOtherOptionSelected === 1 ) {
        return true;
      }

      return false;
    }

    return true;
  };

  const handleAddExperience = async () => {
    try {
      const selected = selectedExperiences.filter(e => e.quantity > 0);

      if (!program?.value?.programId || selected.length === 0) return;

      // 🔒 REQUIRED QUESTION VALIDATION
      const invalidExp = selected.find(exp =>
        exp.question && !isAnswerValid(exp.question)
      );

      // if (invalidExp) {
      //   setFormError(
      //     `Please answer the required question for "${invalidExp.title}".`
      //   );
      //   return;
      // }

      setLoading(true);

      const params = new URLSearchParams();
      params.append("programId", program.value.programId);

      selected.forEach(exp => {
        params.append("ids", exp._id);
      });

      const res = await calculateAddExpAmount(`?${params.toString()}`);

      if (res?.data?.statusCode === 1) {
        setPaymentInfo(res.data.responseData.result);
        setStep("payment");
      }
    } catch (err) {
      console.error("Failed to calculate payment amount", err);
    } finally {
      setLoading(false);
    }
  };

  // COMBINED DROPDOWN OPTIONS (Booking + Program + Camper)
  const purchasedExperienceRows = useMemo(() => {
    const rows = [];

    addExpData.forEach(booking => {
      booking.programs?.forEach(program => {
        program.campers?.forEach(camper => {
          camper.purchasedAdditionalExperiences?.forEach(exp => {
            rows.push({
              camperName: camper.camperName,
              experienceTitle: exp.title,
              bookingNumber: booking.bookingNumber,
              programName: program.programName,
              price: exp.price,
              quantity: exp.numberOfBooking
            });
          });
        });
      });
    });

    return rows;
  }, [addExpData]);

  const combinedOptions = useMemo(() => {
    const options = [];

    addExpData.forEach(booking => {
      booking.programs?.forEach(program => {
        program.campers?.forEach(camper => {
          options.push({
            label: `${booking.bookingNumber} - ${program.programName} - ${camper.camperName}`,
            value: {
              bookingId: booking.bookingId,
              programId: program.programId,
              camperId: camper.camperId,
              campCode: program.campCode,
              camper
            }
          });
        });
      });
    });

    return options;
  }, [addExpData]);

  useEffect(() => {
    if (!isOpen) {
      autoSelectedRef.current = false;
      return;
    }

    if (combinedOptions.length === 1 && !autoSelectedRef.current) {
      autoSelectedRef.current = true;

      const onlyOption = combinedOptions[0];

      setProgram(onlyOption);
      setBooking({ value: onlyOption.value.bookingId });
      setCamper({ value: onlyOption.value.camperId });
      setCampCode(onlyOption.value.campCode);
    }
  }, [combinedOptions, isOpen]);


  const selectedCamper = program?.value?.camper || null;

  useEffect(() => {
    if (!selectedCamper) return;

    const exps = selectedCamper.additionalExperiences || [];

    // ✅ Only ONE experience
    if (exps.length === 1) {
      const exp = exps[0];

      setActiveExpId(exp._id);

      // 🔥 ALSO auto-select it if not already selected
      setSelectedExperiences(prev => {
        const alreadySelected = prev.find(e => e._id === exp._id);
        if (alreadySelected) return prev;

        return [
          {
            ...exp,
            quantity: 1,
            question: exp.question
              ? {
                  ...exp.question,
                  answer: "",
                  answerErr: "",
                  isOtherOptionSelected: 0
                }
              : null
          }
        ];
      });
    }
  }, [selectedCamper]);

  const experienceOptions = selectedCamper
    ? selectedCamper.additionalExperiences.map(exp => ({
        label: `${exp.title} ($${exp.price})`,
        value: exp._id,
        price: exp.price,
        raw: exp // keep full object for later
      }))
    : [];

  const isExpSelected = (expId) =>
    selectedExperiences.some(e => e._id === expId);

  const updateQuantity = (exp, delta) => {
    setSelectedExperiences(prev => {
      const existing = prev.find(e => e._id === exp._id);
      const minQty = 0;
      const maxQty = getMaxQty(exp);

      // first-time add
      if (!existing && delta > 0) {
        return [
          ...prev,
          {
            ...exp,
            quantity: 1,
            question: exp.question
              ? {
                  ...exp.question,
                  answer: "",
                  answerErr: "",
                  isOtherOptionSelected: 0
                }
              : null
          }
        ];
      }

      if (!existing) return prev;

      let newQty = existing.quantity + delta;

      // enforce bounds
      newQty = Math.max(minQty, Math.min(maxQty, newQty));

      // remove if quantity hits 0
      if (newQty === 0) {
        return prev.filter(e => e._id !== exp._id);
      }

      return prev.map(e =>
        e._id === exp._id ? { ...e, quantity: newQty } : e
      );
    });
  };


  const updateAnswer = (expId, value) => {
    setSelectedExperiences(prev =>
      prev.map(exp =>
        exp._id === expId
          ? {
              ...exp,
              question: {
                ...exp.question,
                answer: value,
                answerErr: ""
              }
            }
          : exp
      )
    );
    // setFormError("");

  };

  const toggleOther = (expId) => {
    setSelectedExperiences(prev =>
      prev.map(exp => {
        if (exp._id !== expId) return exp;

        const enableOther = exp.question.isOtherOptionSelected !== 1;

        return {
          ...exp,
          question: {
            ...exp.question,
            isOtherOptionSelected: enableOther ? 1 : 0,
            answer: enableOther ? "" : "", // 🔥 clear answer always
            answerErr: ""
          }
        };
      })
    );
  };

  const buildPurchaseRecord = () => {
    return {
      bookingId: booking?.value,
      programId: program?.value.programId,
      camperId: camper?.value,
      additionalExps: selectedExperiences.filter(e => e.quantity > 0).map(exp => ({
        additionalExperienceId: exp._id,
        price: exp.price,
        numberOfBooking: 1,
        answer: exp.question
          ? {
              questionType: exp.question.questionType,
              title: exp.question.title,
              subTitle: exp.question.subTitle || "",
              options: exp.question.options || [],
              isRequred: exp.question.isRequred,
              isOtherOption: exp.question.isOtherOption,
              answer: exp.question.answer,
              answerErr: exp.question.answerErr || ""
            }
          : {}
      }))
    };
  };

  const handleFinalPurchase = async (paymentPayload) => {
    try {
      setLoading(true);

      const payload = {
        isWeb: 1,
        authPayment: paymentPayload.authPayment,
        token: paymentPayload.token ?? "",
        purchaseRecord: buildPurchaseRecord()
      };

      const res = await purchaseAddExp(payload);

      if (res?.data?.statusCode === 1) {
        notification.success({
          message: "Additional Experience Added",
          description: "Your additional experience has been purchased successfully.",
          placement: "topRight"
        });
        closeModal();
        resetState();
      }
      else{
        notification.error({
          message: "Payment Failed",
          description: "Unable to complete additional experience purchase. Please try again."
        });
      }
    } catch (err) {
      notification.error({
        message: "Something went wrong",
        description: "Payment could not be completed."
      });
      // console.error("Failed to purchase additional experience", err);
    } finally {
      setLoading(false);
    }
  };

  const recalculatePayment = async (experiences) => {
    if (!program?.value?.programId) return;

    const selected = experiences.filter(exp => exp.quantity > 0);

    if (selected.length === 0) {
      setStep("experience");
      setPaymentInfo(null);
      return;
    }

    if (hasInvalidRequiredAnswers(selected)) {
      // notification.error({
      //   message: "Required information missing",
      //   description: "Please answer all required questions before proceeding to payment.",
      //   placement: "topRight"
      // });
      setStep("experience");
      setPaymentInfo(null);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        programId: program.value.programId,
        additionalExperiences: selected.map(exp => ({
          additionalExperienceId: exp._id,
          numberOfBooking: exp.quantity
        }))
      };

      const res = await calculateAddExpAmount(payload);

      if (res?.data?.statusCode === 1) {
        setPaymentInfo(res.data.responseData.result);
        setStep("payment");
      }
    } catch (err) {
      console.error("Price calculation failed", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!isOpen) return;

    recalculatePayment(selectedExperiences);
  }, [selectedExperiences]);

  const getMinQty = () => 0;

  const getMaxQty = (exp) => {
    // mandatory → max 1
    if (exp.isAddexpRequired === 1) return 1;

    // optional → backend-driven limits
    return 1;
  };

  const hasInvalidRequiredAnswers = (experiences) => {
    return experiences.some(exp => {
      if (!exp.question) return false;
      if (exp.question.isRequred !== 1) return false;
      return !isAnswerValid(exp.question);
    });
  };

  return (
    <Modal show={isOpen} onHide={closeModal} centered size="lg">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>Additional Experiences</Modal.Title>

        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={closeModal}
          style={{
            fontSize: "28px",
            lineHeight: "1",
            border: "none",
            background: "transparent",
            cursor: "pointer"
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>

      <Modal.Body>
        {purchasedExperienceRows.length > 0 && (
          <div className="mb-4">
            <h6 className="fw-bold">Purchased Additional Experiences</h6>
            <div className="table-responsive">
              <table className="table table-bordered table-sm">
                <thead className="table-light">
                  <tr>
                    <th>Camper Name</th>
                    <th>Experience Title</th>
                    <th>Booking Number</th>
                    <th>Program Name</th>
                  </tr>
                </thead>
                <tbody>
                  {purchasedExperienceRows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.camperName}</td>
                      <td>{row.experienceTitle}</td>
                      <td>{row.bookingNumber}</td>
                      <td>{row.programName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {purchasedExperienceRows.length > 0 && <hr />}

        <h6 className="fw-bold mb-3">Add Additional Experiences</h6>

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Select Program</Form.Label>

            <Select
              placeholder="Select Program"
              options={combinedOptions}
              value={program}
              isDisabled={step === "payment" || !!paymentInfo}
              onChange={(val) => {
                setProgram(val);
                setBooking({ value: val.value.bookingId });
                setCamper({ value: val.value.camperId });
                setCampCode(val.value.campCode);
                setSelectedExperiences([]);
                setActiveExpId(null);

              }}
            />
          </Form.Group>

          {/* Additional Experiences */}
          <Form.Group className="mb-3">
            <Form.Label>Additional Experiences</Form.Label>

            {!camper && (
              <p className="text-muted">Please select a camper to view experiences</p>
            )}

            {camper && selectedCamper?.additionalExperiences?.length === 0 && (
              <p className="text-muted">No additional experiences available</p>
            )}

            {selectedCamper && selectedCamper.additionalExperiences?.length > 0 && (
              <>
                {/* Tabs Header */}
                <div className="d-flex flex-wrap mb-3 gap-2">
                  {selectedCamper.additionalExperiences.map(exp => {
                    const isSelected = selectedExperiences.some(se => se._id === exp._id);

                    return (
                      <Button
                        key={exp._id}
                        variant={activeExpId === exp._id ? "primary" : "outline-primary"}
                        // disabled={step === "payment"} 
                        size="sm"
                        onClick={() => {
                          setActiveExpId(exp._id);

                          // ✅ Auto-select experience with quantity = 1
                          setSelectedExperiences(prev => {
                            const existing = prev.find(e => e._id === exp._id);
                            if (existing) return prev;

                            return [
                              ...prev,
                              {
                                ...exp,
                                quantity: 1,
                                question: exp.question
                                  ? {
                                      ...exp.question,
                                      answer: "",
                                      answerErr: "",
                                      isOtherOptionSelected: 0
                                    }
                                  : null
                              }
                            ];
                          });
                        }}

                      >
                        {exp.title}
                      </Button>
                    );
                  })}
                </div>

                {/* Active Tab Content */}
                {activeExpId && (() => {
                  const exp = selectedCamper.additionalExperiences.find(
                    e => e._id === activeExpId
                  );

                  const selectedExp =
                    selectedExperiences.find(se => se._id === activeExpId) || { quantity: 0 };

                  if (!exp) return null;

                  return (
                    <div style={{ color: exp.color }} className="border rounded p-3 bg-light">
                      <h5>{exp.title}</h5>
                      <p><b>Price:</b> ${exp.price}</p>

                      {exp.description && (
                        <p className="text-muted">{getHtml(exp.description)}</p>
                      )}

                      {/* QUANTITY BAR */}
                      <div className="d-flex align-items-center gap-2 mt-2">
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onClick={() => updateQuantity(exp, -1)}
                          disabled={selectedExp.quantity === 0}
                        >
                          –
                        </Button>

                        <span className="fw-bold">
                          {selectedExp.quantity}
                        </span>

                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => updateQuantity(exp, 1)}
                          disabled={selectedExp.quantity >= getMaxQty(exp)}
                        >
                          +
                        </Button>

                      </div>

                      {/* QUESTION AREA (ONLY WHEN SELECTED) */}
                      {selectedExp.quantity > 0 && selectedExp.question && (
                        <div className="mt-3">
                          <p className="m-0">
                            <b>Q.</b> {selectedExp.question.title}
                            {selectedExp.question.isRequred === 1 && (
                              <span className="text-danger"> *</span>
                            )}
                          </p>

                          {selectedExp.question.questionType === 1 && (
                            <textarea
                              className="form-control"
                              value={selectedExp.question.answer}
                              // disabled={step === "payment"} 
                              onChange={e =>
                                updateAnswer(exp._id, e.target.value)
                              }
                            />
                          )}

                          {selectedExp.question.questionType === 2 && (
                            <Select
                              classNamePrefix="cm_select mt-2"
                              value={
                                selectedExp.question.answer
                                  ? {
                                      label: selectedExp.question.answer,
                                      value: selectedExp.question.answer
                                    }
                                  : null
                              }
                              onChange={opt => updateAnswer(exp._id, opt.value)}
                              options={selectedExp.question.options.map(o => ({
                                label: o.opt,
                                value: o.opt
                              }))}
                              menuPlacement="bottom"
                              menuPosition="absolute"
                            />
                          )}

                          {selectedExp.question.questionType === 4 && (
                            <div className="mt-2">
                              {selectedExp.question.options.map((o, i) => (
                                <div
                                  key={i}
                                  className="check_box_wrapper cm_dark_check d-flex align-items-center mb-1"
                                >
                                  <input
                                    type="checkbox"
                                    // disabled={step === "payment"}   // lock during payment
                                    checked={selectedExp.question.answer === o.opt}
                                    onChange={() => {
                                      setSelectedExperiences(prev =>
                                        prev.map(se => {
                                          if (se._id !== exp._id) return se;

                                          return {
                                            ...se,
                                            question: {
                                              ...se.question,
                                              answer: o.opt,
                                              isOtherOptionSelected: 0,
                                              answerErr: ""
                                            }
                                          };
                                        })
                                      );
                                    }}


                                  />
                                  <span className="check_box"><span /></span>
                                  <p className="mb-0 ms-2">{o.opt}</p>
                                </div>
                              ))}

                              {/* OTHER OPTION */}
                              {selectedExp.question.isOtherOption === 1 && (
                                <div className="check_box_wrapper cm_dark_check mt-2">
                                  <input
                                    type="checkbox"
                                    // disabled={step === "payment"}   // 🔒 lock during payment
                                    checked={selectedExp.question.isOtherOptionSelected === 1}
                                    onChange={() => {
                                      // if (step === "payment") return;
                                      toggleOther(exp._id);
                                    }}
                                  />
                                  <span className="check_box"><span /></span>
                                  <p className="mb-0 ms-2">Other</p>
                                </div>
                              )}

                              {selectedExp.question.isOtherOptionSelected === 1 && (
                                <textarea
                                  className="form-control mt-2"
                                  value={selectedExp.question.answer}
                                  // disabled={step === "payment"}
                                  onChange={e => {
                                    // if (step === "payment") return;

                                    setSelectedExperiences(prev =>
                                      prev.map(se =>
                                        se._id === exp._id
                                          ? {
                                              ...se,
                                              question: {
                                                ...se.question,
                                                answer: e.target.value,
                                                isOtherOptionSelected: 1,
                                                answerErr: ""
                                              }
                                            }
                                          : se
                                      )
                                    );
                                  }}
                                />
                              )}

                            </div>
                          )}

                        </div>
                      )}
                    </div>
                  );
                })()}
              </>
            )}

          </Form.Group>

        </Form>

        {/* { paymentInfo &&  (
          <p className="text-center text-muted mb-3">
            Total Additional Experience Amount: $
            {paymentInfo.f_payableAmount}
          </p>
        )} */}

        {step === "payment" && paymentInfo && (
          <>
            <p className="text-center text-muted mb-3">
              Total Additional Experience Amount: $
              {paymentInfo.f_payableAmount}
            </p>

            <GenericPaymentGateway
              creditCardPayInfo={paymentInfo.creditCardPayInfo}
              internetBankPayInfo={paymentInfo.internetBankPayInfo}
              userId={userId}
              campCode={campCode}
              userEmail={userEmail}
              onSubmit={(paymentPayload) => {
                handleFinalPurchase(paymentPayload);
              }}
              onCancel={() => setStep("experience")}
            />
          </>
        )}

      </Modal.Body>
      
      {/* {formError && formError !== "" && (
        <div className="alert alert-danger mt-3 mb-0">
          {formError}
        </div>
      )} */}

      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        {/* {step !== "payment" && (
          <Button
            variant="primary"
            disabled={
              !selectedCamper ||
              selectedExperiences.filter(e => e.quantity === 1).length === 0 ||
              loading
            }
            onClick={handleAddExperience}
          >
            Add Experience
          </Button>
        )} */}
      </Modal.Footer>
    </Modal>
  );
};

export default AdditionalExperienceModal;
